export default "__VITE_ASSET__DDfxJIYG__"